<template>
  <div class="relative">
    <div
      v-if="typeof nTabs === 'number'"
      ref="scrollContainer"
      class="mb-2 flex items-center overflow-x-hidden"
      :class="[justify]"
    >
      <div
        v-for="index in nTabs"
        :key="index"
        class="mr-10 lg:mr-8"
        :style="[fixedTabSize ? 'text-wrap: nowrap' : '']"
      >
        <p
          class="cursor-pointer text-left text-sm text-grey-2"
          :class="index === activeTab ? 'font-semibold' : 'text-grey-2 text-opacity-50'"
          @click="changeTab(index)"
        >
          {{
            $t(labels + '.' + index, {
              labelData: labelsData[index - 1],
            })
          }}
        </p>
        <div
          class="mt-2 h-1 w-6 transition duration-500 ease-in-out"
          :class="index === activeTab ? 'bg-orange-2' : 'bg-none'"
        />
      </div>
    </div>
    <div v-else class="mb-2 flex items-center justify-start">
      <div v-for="(tab, index) in nTabs" :key="index" class="mr-10 lg:mr-8">
        <p
          class="cursor-pointer text-left text-sm text-grey-2"
          :class="index + 1 === activeTab ? 'font-semibold' : 'text-grey-2 text-opacity-50'"
          @click="changeTab(index + 1)"
        >
          {{ tab }}
        </p>
        <div class="mt-2 h-1 w-6" :class="index + 1 === activeTab ? 'bg-orange-2' : 'bg-none'" />
      </div>
    </div>
    <div class="absolute bottom-0 h-px w-full bg-grey-2 bg-opacity-10" />
  </div>
</template>

<script>
import { useVModel } from 'vue-composable'
import Hammer from 'hammerjs'
import { ref, onMounted } from 'vue'
export default {
  props: {
    labels: {
      type: String,
      default: '',
    },
    labelsData: {
      type: Array,
      default: () => [],
    },
    nTabs: {
      type: [Number, Array],
    },
    current: {
      type: Number,
      default: 1,
    },
    anchors: {
      type: Array,
      default: () => [],
    },
    fixedTabSize: {
      type: Boolean,
      default: false,
    },
    justify: {
      type: String,
      default: 'justify-start',
    },
  },
  setup(props) {
    const activeTab = useVModel(props, 'current')
    const scrollContainer = ref(null)
    const lastScrollLeft = ref(0)

    const changeTab = (newTab) => {
      activeTab.value = newTab
    }

    onMounted(async () => {
      const hammer = new Hammer(scrollContainer.value)
      hammer.get('pan').set({ direction: Hammer.DIRECTION_HORIZONTAL })

      hammer.on('panstart', () => {
        lastScrollLeft.value = scrollContainer.value.scrollLeft
      })

      hammer.on('panmove', (event) => {
        scrollContainer.value.scrollLeft = lastScrollLeft.value - event.deltaX
      })

      hammer.on('panend', () => {
        lastScrollLeft.value = scrollContainer.value.scrollLeft
      })
    })

    return {
      activeTab,
      changeTab,
      scrollContainer,
    }
  },
}
</script>
